import { render, staticRenderFns } from "./HeaderGame.vue?vue&type=template&id=591d940f&scoped=true&"
import script from "./HeaderGame.vue?vue&type=script&lang=js&"
export * from "./HeaderGame.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGame.vue?vue&type=style&index=0&id=591d940f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d940f",
  null
  
)

export default component.exports